export default function getBoardName(
  publicName?: string,
  subStyles: any[] = [],
  boardRoomType: string = '',
) {
  if (publicName) {
    return publicName;
  }

  const boardStyles = subStyles.filter((subStyle) => subStyle).map((subStyle:any) => subStyle.name);

  return `${boardStyles.join(', ')} ${boardRoomType}`.trim();
}
